import type { ComponentType, CSSProperties } from "react";
import type { TFunction } from "i18next";
import {
  TagOutlined,
  SettingOutlined,
  MonitorOutlined,
  BarChartOutlined,
  CalendarOutlined,
  DatabaseOutlined,
  TruckOutlined,
  // TagsOutlined, // used by Discounts module (temporarily hidden)
  EyeOutlined,
} from "@ant-design/icons";
import { SparklesIcon } from "./components/SparklesIcon";
import { DEFAULT_INVENTORY_SLUG } from "../inventory/components/shell/inventoryNav";

export type Module = {
  roleName?: string;
  key: string;
  title: string;
  desc: string;
  Icon: ComponentType<{ style?: CSSProperties }>;
  path: string;
  // Модулът не е готов — при клик показваме "Очаквайте скоро" вместо да навигираме
  comingSoon?: boolean;
  // Служебен модул — вижда се само от администратора (user id = 1)
  adminOnly?: boolean;
  // При архивиран ресторант модулът се вижда само в тестов режим (access)
  requiresAccess?: boolean;
};

/** „AI интеграции" — витрина без екран и без право: кликът отваря
 *  `AiIntegrationsModal` вместо общото „Очаквайте скоро". */
export const AI_INTEGRATIONS_KEY = "aiIntegrations";

/** Всички модули на началния екран в реда им; кои се виждат решава `Modules`
 *  (роля, adminOnly, тестов режим). Изваден от `Modules.tsx`. */
export const buildModules = (t: TFunction): Module[] => [
  {
    roleName: "ordering",
    key: "ordering",
    title: t("modules.ordering"),
    desc: t("modules.orderingDesc"),
    Icon: TagOutlined,
    path: "/ordering",
  },
  {
    roleName: "configuration",
    key: "configuration",
    title: t("modules.configuration"),
    desc: t("modules.configurationDesc"),
    Icon: SettingOutlined,
    path: "/configuration",
  },
  {
    roleName: "monitors",
    key: "monitors",
    title: t("modules.monitors"),
    desc: t("modules.monitorsDesc"),
    Icon: MonitorOutlined,
    path: "/monitors",
  },
  {
    roleName: "reports",
    key: "reports",
    title: t("modules.reports"),
    desc: t("modules.reportsDesc"),
    Icon: BarChartOutlined,
    // Крайните адреси, не пренасочващите /reports и /inventory: пренасочването
    // би показало празен екран, докато се зарежда кодът на модула
    // (docs/architecture.md §Код при отваряне).
    path: "/reports/dashboard",
  },
  {
    roleName: "reservations",
    key: "reservations",
    title: t("modules.reservations"),
    desc: t("modules.reservationsDesc"),
    Icon: CalendarOutlined,
    path: "/reservations",
  },
  {
    roleName: "inventory",
    key: "inventory",
    title: t("modules.inventory"),
    desc: t("modules.inventoryDesc"),
    Icon: DatabaseOutlined,
    path: `/inventory/${DEFAULT_INVENTORY_SLUG}`,
    requiresAccess: true,
  },
  // Отстъпки — временно скрит модул (очаква се)
  // {
  //   roleName: "discounts",
  //   key: "discounts",
  //   title: t("modules.discounts"),
  //   desc: t("modules.discountsDesc"),
  //   Icon: TagsOutlined,
  //   path: "/discounts",
  // },
  {
    roleName: "delivery",
    key: "delivery",
    title: t("modules.delivery"),
    desc: t("modules.deliveryDesc"),
    Icon: TruckOutlined,
    path: "/delivery",
    comingSoon: true,
  },
  // Без roleName — вижда се от всички.
  {
    key: AI_INTEGRATIONS_KEY,
    title: t("modules.aiIntegrations"),
    desc: t("modules.aiIntegrationsDesc"),
    Icon: SparklesIcon,
    path: "",
    comingSoon: true,
  },
  {
    key: "monitoring",
    title: t("modules.monitoring"),
    desc: t("modules.monitoringDesc"),
    Icon: EyeOutlined,
    path: "/monitoring",
    adminOnly: true,
  },
];
